import React, { useState } from 'react';

// 「説明例」＝正当化→修正の2段構成（2026-07-15研究発表で合意した方法論に対応）。
// 具体的な部品名・直し方は書かない：その問の答えを与えず、穴埋めの型だけを真似させる。
// 開閉式にしているのは実験上の理由——誰がテンプレを参照したかをログで切り分けるため、
// 常時表示にはしない（開いた事実は親が onOpen 経由で Supabase に記録する）。
//
// shape-change / gaze-control の文型は選択式（SelfExpSelect）と揃える。
// **一人称（「わたしは◯◯と思っていたので」）は使わない**（2026-10-02変更）：指摘の対象は
// 他者のデッサンであり、その既存知識を持つ学習者と持たない学習者がいるため、自分の思い込みと
// して断定させない。カテゴリスキーマによる誤りとして提示する記述文にする。
// **「実際のモチーフでは〜に見える」は置かない**（2026-10-03変更）：直し方の根拠はガイドの結果
// （形を変えると3Dモデルのおかしさが消える／視点を動かすとおかしな箇所がモチーフと同じに見えた）に置く。
const TEMPLATE_BY_PHASE = {
  'part-select':
    '「◯◯（誤っている部品）は、□□のように描かれています。でも実際のモチーフでは△△なので、××のように直すとモチーフに近づきます。」',
  'shape-change':
    '「デッサンの3Dモデルを◯◯（視点）から見てみると、□□（おかしな見え）。このおかしさは△△のように描いている点にあり、▲▲（思い込み）という知識にとらわれた誤りである。形を変えると3Dモデルのおかしさが消えるので、××のように描きなおせばよい。」',
  'gaze-control':
    '「デッサンの3Dモデルを◯◯（視点）から見てみると、□□（おかしな見え）。このおかしさは△△のように描いている点にあり、▲▲（思い込み）という知識にとらわれた誤りである。視点を××と、おかしな箇所がモチーフと同じに見えたので、このデッサンは別の視点から見た形を描いている。」',
};
const TEMPLATE_HINTS = {
  'part-select':
    '◯◯・□□・△△・××をあなたの言葉に置きかえて説明してみよう',
  'shape-change':
    '◯◯・□□・△△・▲▲・××をあなたの言葉に置きかえて説明してみよう',
  'gaze-control':
    '◯◯・□□・△△・▲▲・××をあなたの言葉に置きかえて説明してみよう'
  }

export default function SelfExpTemplate({ phase, onOpen }) {
  const [open, setOpen] = useState(false);
  const template = TEMPLATE_BY_PHASE[phase] || TEMPLATE_BY_PHASE['part-select'];
  const hint = TEMPLATE_HINTS[phase] || TEMPLATE_HINTS['part-select'];

  const handleToggle = () => {
    const next = !open;
    setOpen(next);
    if (next && typeof onOpen === 'function') onOpen();
  };

  return (
    <div className="selfexp-template">
      <button
        type="button"
        className="selfexp-template__toggle"
        onClick={handleToggle}
        aria-expanded={open}
      >
        {open ? '説明例を閉じる ▲' : '💡 説明例を見る ▼'}
      </button>
      {open && (
        <div className="selfexp-template__box">
          <p className="selfexp-template__frame">{template}</p>
          <p className="selfexp-template__hint">{hint}</p>
        </div>
      )}
    </div>
  );
}
